// source: pbtypes/gen/vehicle_params_for_phone/vehicle_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_calibration_camera_rig_pb = require('../../../pbtypes/gen/calibration/camera_rig_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_camera_rig_pb);
var pbtypes_gen_common_string_key_value_pb = require('../../../pbtypes/gen/common/string_key_value_pb.js');
goog.object.extend(proto, pbtypes_gen_common_string_key_value_pb);
var pbtypes_gen_flir_boson_driver_agc_settings_pb = require('../../../pbtypes/gen/flir_boson_driver/agc_settings_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_agc_settings_pb);
var pbtypes_gen_joysticks_rate_limits_pb = require('../../../pbtypes/gen/joysticks/rate_limits_pb.js');
goog.object.extend(proto, pbtypes_gen_joysticks_rate_limits_pb);
var pbtypes_gen_run_modes_run_mode_info_pb = require('../../../pbtypes/gen/run_modes/run_mode_info_pb.js');
goog.object.extend(proto, pbtypes_gen_run_modes_run_mode_info_pb);
var pbtypes_gen_skills_control_scheme_params_pb = require('../../../pbtypes/gen/skills/control_scheme_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_control_scheme_params_pb);
var pbtypes_gen_skybus_tunnel_tunnel_channel_pb = require('../../../pbtypes/gen/skybus_tunnel/tunnel_channel_pb.js');
goog.object.extend(proto, pbtypes_gen_skybus_tunnel_tunnel_channel_pb);
var pbtypes_gen_vehicle_params_for_phone_camera_params_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/camera_params_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_camera_params_pb);
var pbtypes_gen_vehicle_params_for_phone_compatibility_info_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/compatibility_info_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_compatibility_info_pb);
var pbtypes_gen_vehicle_params_for_phone_return_settings_limits_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/return_settings_limits_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_return_settings_limits_pb);
var pbtypes_gen_vehicle_params_for_phone_runmode_switching_option_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/runmode_switching_option_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_runmode_switching_option_pb);
var pbtypes_gen_vehicle_params_for_phone_skill_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/skill_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_skill_pb);
var pbtypes_gen_vehicle_params_for_phone_subject_params_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/subject_params_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_subject_params_pb);
var pbtypes_gen_vehicle_params_for_phone_vehicle_features_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/vehicle_features_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_vehicle_features_pb);
var pbtypes_gen_vehicle_params_for_phone_waypoint_limits_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/waypoint_limits_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_waypoint_limits_pb);
goog.exportSymbol('proto.vehicle_params_for_phone.VehicleParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_params_for_phone.VehicleParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vehicle_params_for_phone.VehicleParams.repeatedFields_, null);
};
goog.inherits(proto.vehicle_params_for_phone.VehicleParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_params_for_phone.VehicleParams.displayName = 'proto.vehicle_params_for_phone.VehicleParams';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vehicle_params_for_phone.VehicleParams.repeatedFields_ = [2,3,4,7,9,10,28];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_params_for_phone.VehicleParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_params_for_phone.VehicleParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.VehicleParams.toObject = function(includeInstance, msg) {
  var f, obj = {
valid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
availableSkillsList: jspb.Message.toObjectList(msg.getAvailableSkillsList(),
    pbtypes_gen_vehicle_params_for_phone_skill_pb.Skill.toObject, includeInstance),
skillsetsHash: jspb.Message.getFieldWithDefault(msg, 12, ""),
tunnelChannelListList: jspb.Message.toObjectList(msg.getTunnelChannelListList(),
    pbtypes_gen_skybus_tunnel_tunnel_channel_pb.TunnelChannel.toObject, includeInstance),
mobileLoggerChannelsToBlacklistList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
previewCameraIndex: jspb.Message.getFieldWithDefault(msg, 5, 0),
previewCameraRig: (f = msg.getPreviewCameraRig()) && pbtypes_gen_calibration_camera_rig_pb.CameraRig.toObject(includeInstance, f),
previewStreamFps: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
subjectCamera: (f = msg.getSubjectCamera()) && pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams.toObject(includeInstance, f),
infraredCamera: (f = msg.getInfraredCamera()) && pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams.toObject(includeInstance, f),
runModeListList: jspb.Message.toObjectList(msg.getRunModeListList(),
    pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo.toObject, includeInstance),
subjectParams: (f = msg.getSubjectParams()) && pbtypes_gen_vehicle_params_for_phone_subject_params_pb.SubjectParams.toObject(includeInstance, f),
vehicleOptionsList: jspb.Message.toObjectList(msg.getVehicleOptionsList(),
    pbtypes_gen_common_string_key_value_pb.StringKeyValue.toObject, includeInstance),
vehicleOverridesList: jspb.Message.toObjectList(msg.getVehicleOverridesList(),
    pbtypes_gen_common_string_key_value_pb.StringKeyValue.toObject, includeInstance),
minimumApiVersionMinor: jspb.Message.getFieldWithDefault(msg, 14, 0),
features: (f = msg.getFeatures()) && pbtypes_gen_vehicle_params_for_phone_vehicle_features_pb.VehicleFeatures.toObject(includeInstance, f),
controlScheme: (f = msg.getControlScheme()) && pbtypes_gen_skills_control_scheme_params_pb.ControlSchemeParams.toObject(includeInstance, f),
joysticksRateLimits: (f = msg.getJoysticksRateLimits()) && pbtypes_gen_joysticks_rate_limits_pb.RateLimits.toObject(includeInstance, f),
offlineModeEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
enableMapQuadSelector: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
ignoresLoggingSdCard: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
compatibilityInfo: (f = msg.getCompatibilityInfo()) && pbtypes_gen_vehicle_params_for_phone_compatibility_info_pb.CompatibilityInfo.toObject(includeInstance, f),
returnSettingsLimits: (f = msg.getReturnSettingsLimits()) && pbtypes_gen_vehicle_params_for_phone_return_settings_limits_pb.ReturnSettingsLimits.toObject(includeInstance, f),
waypointLimits: (f = msg.getWaypointLimits()) && pbtypes_gen_vehicle_params_for_phone_waypoint_limits_pb.WaypointLimits.toObject(includeInstance, f),
allowAutonomyOff: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
runmodeSwitchingOptionsList: jspb.Message.toObjectList(msg.getRunmodeSwitchingOptionsList(),
    pbtypes_gen_vehicle_params_for_phone_runmode_switching_option_pb.RunmodeSwitchingOption.toObject, includeInstance),
maxHeightGpsUnreliableIndoors: jspb.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
maxHeightGpsUnreliable: jspb.Message.getFloatingPointFieldWithDefault(msg, 33, 0.0),
maxHeightGpsUnreliableNightAutonomy: jspb.Message.getFloatingPointFieldWithDefault(msg, 34, 0.0),
thermalCameraRows: jspb.Message.getFieldWithDefault(msg, 30, 0),
thermalCameraCols: jspb.Message.getFieldWithDefault(msg, 31, 0),
defaultThermalAgcSettings: (f = msg.getDefaultThermalAgcSettings()) && pbtypes_gen_flir_boson_driver_agc_settings_pb.AgcSettings.toObject(includeInstance, f),
enableOverlayPhotoKey: jspb.Message.getFieldWithDefault(msg, 35, ""),
maxNumLogsPreventDeletion: jspb.Message.getFieldWithDefault(msg, 36, 0),
disableLrvRecordingKey: jspb.Message.getFieldWithDefault(msg, 37, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_params_for_phone.VehicleParams}
 */
proto.vehicle_params_for_phone.VehicleParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_params_for_phone.VehicleParams;
  return proto.vehicle_params_for_phone.VehicleParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_params_for_phone.VehicleParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_params_for_phone.VehicleParams}
 */
proto.vehicle_params_for_phone.VehicleParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    case 2:
      var value = new pbtypes_gen_vehicle_params_for_phone_skill_pb.Skill;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_skill_pb.Skill.deserializeBinaryFromReader);
      msg.addAvailableSkills(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSkillsetsHash(value);
      break;
    case 3:
      var value = new pbtypes_gen_skybus_tunnel_tunnel_channel_pb.TunnelChannel;
      reader.readMessage(value,pbtypes_gen_skybus_tunnel_tunnel_channel_pb.TunnelChannel.deserializeBinaryFromReader);
      msg.addTunnelChannelList(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addMobileLoggerChannelsToBlacklist(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setPreviewCameraIndex(value);
      break;
    case 6:
      var value = new pbtypes_gen_calibration_camera_rig_pb.CameraRig;
      reader.readMessage(value,pbtypes_gen_calibration_camera_rig_pb.CameraRig.deserializeBinaryFromReader);
      msg.setPreviewCameraRig(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPreviewStreamFps(value);
      break;
    case 22:
      var value = new pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams.deserializeBinaryFromReader);
      msg.setSubjectCamera(value);
      break;
    case 23:
      var value = new pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams.deserializeBinaryFromReader);
      msg.setInfraredCamera(value);
      break;
    case 7:
      var value = new pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo;
      reader.readMessage(value,pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo.deserializeBinaryFromReader);
      msg.addRunModeList(value);
      break;
    case 8:
      var value = new pbtypes_gen_vehicle_params_for_phone_subject_params_pb.SubjectParams;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_subject_params_pb.SubjectParams.deserializeBinaryFromReader);
      msg.setSubjectParams(value);
      break;
    case 9:
      var value = new pbtypes_gen_common_string_key_value_pb.StringKeyValue;
      reader.readMessage(value,pbtypes_gen_common_string_key_value_pb.StringKeyValue.deserializeBinaryFromReader);
      msg.addVehicleOptions(value);
      break;
    case 10:
      var value = new pbtypes_gen_common_string_key_value_pb.StringKeyValue;
      reader.readMessage(value,pbtypes_gen_common_string_key_value_pb.StringKeyValue.deserializeBinaryFromReader);
      msg.addVehicleOverrides(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setMinimumApiVersionMinor(value);
      break;
    case 16:
      var value = new pbtypes_gen_vehicle_params_for_phone_vehicle_features_pb.VehicleFeatures;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_vehicle_features_pb.VehicleFeatures.deserializeBinaryFromReader);
      msg.setFeatures(value);
      break;
    case 17:
      var value = new pbtypes_gen_skills_control_scheme_params_pb.ControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_control_scheme_params_pb.ControlSchemeParams.deserializeBinaryFromReader);
      msg.setControlScheme(value);
      break;
    case 18:
      var value = new pbtypes_gen_joysticks_rate_limits_pb.RateLimits;
      reader.readMessage(value,pbtypes_gen_joysticks_rate_limits_pb.RateLimits.deserializeBinaryFromReader);
      msg.setJoysticksRateLimits(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineModeEnabled(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMapQuadSelector(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIgnoresLoggingSdCard(value);
      break;
    case 24:
      var value = new pbtypes_gen_vehicle_params_for_phone_compatibility_info_pb.CompatibilityInfo;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_compatibility_info_pb.CompatibilityInfo.deserializeBinaryFromReader);
      msg.setCompatibilityInfo(value);
      break;
    case 25:
      var value = new pbtypes_gen_vehicle_params_for_phone_return_settings_limits_pb.ReturnSettingsLimits;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_return_settings_limits_pb.ReturnSettingsLimits.deserializeBinaryFromReader);
      msg.setReturnSettingsLimits(value);
      break;
    case 26:
      var value = new pbtypes_gen_vehicle_params_for_phone_waypoint_limits_pb.WaypointLimits;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_waypoint_limits_pb.WaypointLimits.deserializeBinaryFromReader);
      msg.setWaypointLimits(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowAutonomyOff(value);
      break;
    case 28:
      var value = new pbtypes_gen_vehicle_params_for_phone_runmode_switching_option_pb.RunmodeSwitchingOption;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_runmode_switching_option_pb.RunmodeSwitchingOption.deserializeBinaryFromReader);
      msg.addRunmodeSwitchingOptions(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxHeightGpsUnreliableIndoors(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxHeightGpsUnreliable(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxHeightGpsUnreliableNightAutonomy(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setThermalCameraRows(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setThermalCameraCols(value);
      break;
    case 32:
      var value = new pbtypes_gen_flir_boson_driver_agc_settings_pb.AgcSettings;
      reader.readMessage(value,pbtypes_gen_flir_boson_driver_agc_settings_pb.AgcSettings.deserializeBinaryFromReader);
      msg.setDefaultThermalAgcSettings(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEnableOverlayPhotoKey(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setMaxNumLogsPreventDeletion(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDisableLrvRecordingKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_params_for_phone.VehicleParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_params_for_phone.VehicleParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.VehicleParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAvailableSkillsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      pbtypes_gen_vehicle_params_for_phone_skill_pb.Skill.serializeBinaryToWriter
    );
  }
  f = message.getSkillsetsHash();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTunnelChannelListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      pbtypes_gen_skybus_tunnel_tunnel_channel_pb.TunnelChannel.serializeBinaryToWriter
    );
  }
  f = message.getMobileLoggerChannelsToBlacklistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getPreviewCameraIndex();
  if (f !== 0) {
    writer.writeSint32(
      5,
      f
    );
  }
  f = message.getPreviewCameraRig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_gen_calibration_camera_rig_pb.CameraRig.serializeBinaryToWriter
    );
  }
  f = message.getPreviewStreamFps();
  if (f !== 0.0) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = message.getSubjectCamera();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams.serializeBinaryToWriter
    );
  }
  f = message.getInfraredCamera();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams.serializeBinaryToWriter
    );
  }
  f = message.getRunModeListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo.serializeBinaryToWriter
    );
  }
  f = message.getSubjectParams();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      pbtypes_gen_vehicle_params_for_phone_subject_params_pb.SubjectParams.serializeBinaryToWriter
    );
  }
  f = message.getVehicleOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      pbtypes_gen_common_string_key_value_pb.StringKeyValue.serializeBinaryToWriter
    );
  }
  f = message.getVehicleOverridesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      pbtypes_gen_common_string_key_value_pb.StringKeyValue.serializeBinaryToWriter
    );
  }
  f = message.getMinimumApiVersionMinor();
  if (f !== 0) {
    writer.writeSint32(
      14,
      f
    );
  }
  f = message.getFeatures();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      pbtypes_gen_vehicle_params_for_phone_vehicle_features_pb.VehicleFeatures.serializeBinaryToWriter
    );
  }
  f = message.getControlScheme();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      pbtypes_gen_skills_control_scheme_params_pb.ControlSchemeParams.serializeBinaryToWriter
    );
  }
  f = message.getJoysticksRateLimits();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      pbtypes_gen_joysticks_rate_limits_pb.RateLimits.serializeBinaryToWriter
    );
  }
  f = message.getOfflineModeEnabled();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getEnableMapQuadSelector();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getIgnoresLoggingSdCard();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getCompatibilityInfo();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      pbtypes_gen_vehicle_params_for_phone_compatibility_info_pb.CompatibilityInfo.serializeBinaryToWriter
    );
  }
  f = message.getReturnSettingsLimits();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      pbtypes_gen_vehicle_params_for_phone_return_settings_limits_pb.ReturnSettingsLimits.serializeBinaryToWriter
    );
  }
  f = message.getWaypointLimits();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      pbtypes_gen_vehicle_params_for_phone_waypoint_limits_pb.WaypointLimits.serializeBinaryToWriter
    );
  }
  f = message.getAllowAutonomyOff();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getRunmodeSwitchingOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      28,
      f,
      pbtypes_gen_vehicle_params_for_phone_runmode_switching_option_pb.RunmodeSwitchingOption.serializeBinaryToWriter
    );
  }
  f = message.getMaxHeightGpsUnreliableIndoors();
  if (f !== 0.0) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getMaxHeightGpsUnreliable();
  if (f !== 0.0) {
    writer.writeDouble(
      33,
      f
    );
  }
  f = message.getMaxHeightGpsUnreliableNightAutonomy();
  if (f !== 0.0) {
    writer.writeDouble(
      34,
      f
    );
  }
  f = message.getThermalCameraRows();
  if (f !== 0) {
    writer.writeSint32(
      30,
      f
    );
  }
  f = message.getThermalCameraCols();
  if (f !== 0) {
    writer.writeSint32(
      31,
      f
    );
  }
  f = message.getDefaultThermalAgcSettings();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      pbtypes_gen_flir_boson_driver_agc_settings_pb.AgcSettings.serializeBinaryToWriter
    );
  }
  f = message.getEnableOverlayPhotoKey();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getMaxNumLogsPreventDeletion();
  if (f !== 0) {
    writer.writeSint32(
      36,
      f
    );
  }
  f = message.getDisableLrvRecordingKey();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
};


/**
 * optional bool valid = 1;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated Skill available_skills = 2;
 * @return {!Array<!proto.vehicle_params_for_phone.Skill>}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getAvailableSkillsList = function() {
  return /** @type{!Array<!proto.vehicle_params_for_phone.Skill>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_vehicle_params_for_phone_skill_pb.Skill, 2));
};


/**
 * @param {!Array<!proto.vehicle_params_for_phone.Skill>} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setAvailableSkillsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vehicle_params_for_phone.Skill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle_params_for_phone.Skill}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.addAvailableSkills = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vehicle_params_for_phone.Skill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearAvailableSkillsList = function() {
  return this.setAvailableSkillsList([]);
};


/**
 * optional string skillsets_hash = 12;
 * @return {string}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getSkillsetsHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setSkillsetsHash = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated skybus_tunnel.TunnelChannel tunnel_channel_list = 3;
 * @return {!Array<!proto.skybus_tunnel.TunnelChannel>}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getTunnelChannelListList = function() {
  return /** @type{!Array<!proto.skybus_tunnel.TunnelChannel>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_skybus_tunnel_tunnel_channel_pb.TunnelChannel, 3));
};


/**
 * @param {!Array<!proto.skybus_tunnel.TunnelChannel>} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setTunnelChannelListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.skybus_tunnel.TunnelChannel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skybus_tunnel.TunnelChannel}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.addTunnelChannelList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.skybus_tunnel.TunnelChannel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearTunnelChannelListList = function() {
  return this.setTunnelChannelListList([]);
};


/**
 * repeated string mobile_logger_channels_to_blacklist = 4;
 * @return {!Array<string>}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getMobileLoggerChannelsToBlacklistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setMobileLoggerChannelsToBlacklistList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.addMobileLoggerChannelsToBlacklist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearMobileLoggerChannelsToBlacklistList = function() {
  return this.setMobileLoggerChannelsToBlacklistList([]);
};


/**
 * optional sint32 preview_camera_index = 5;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getPreviewCameraIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setPreviewCameraIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional calibration.CameraRig preview_camera_rig = 6;
 * @return {?proto.calibration.CameraRig}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getPreviewCameraRig = function() {
  return /** @type{?proto.calibration.CameraRig} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_calibration_camera_rig_pb.CameraRig, 6));
};


/**
 * @param {?proto.calibration.CameraRig|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setPreviewCameraRig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearPreviewCameraRig = function() {
  return this.setPreviewCameraRig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasPreviewCameraRig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional float preview_stream_fps = 13;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getPreviewStreamFps = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setPreviewStreamFps = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional CameraParams subject_camera = 22;
 * @return {?proto.vehicle_params_for_phone.CameraParams}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getSubjectCamera = function() {
  return /** @type{?proto.vehicle_params_for_phone.CameraParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams, 22));
};


/**
 * @param {?proto.vehicle_params_for_phone.CameraParams|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setSubjectCamera = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearSubjectCamera = function() {
  return this.setSubjectCamera(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasSubjectCamera = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional CameraParams infrared_camera = 23;
 * @return {?proto.vehicle_params_for_phone.CameraParams}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getInfraredCamera = function() {
  return /** @type{?proto.vehicle_params_for_phone.CameraParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_camera_params_pb.CameraParams, 23));
};


/**
 * @param {?proto.vehicle_params_for_phone.CameraParams|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setInfraredCamera = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearInfraredCamera = function() {
  return this.setInfraredCamera(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasInfraredCamera = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * repeated run_modes.RunModeInfo run_mode_list = 7;
 * @return {!Array<!proto.run_modes.RunModeInfo>}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getRunModeListList = function() {
  return /** @type{!Array<!proto.run_modes.RunModeInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo, 7));
};


/**
 * @param {!Array<!proto.run_modes.RunModeInfo>} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setRunModeListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.run_modes.RunModeInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.run_modes.RunModeInfo}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.addRunModeList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.run_modes.RunModeInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearRunModeListList = function() {
  return this.setRunModeListList([]);
};


/**
 * optional SubjectParams subject_params = 8;
 * @return {?proto.vehicle_params_for_phone.SubjectParams}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getSubjectParams = function() {
  return /** @type{?proto.vehicle_params_for_phone.SubjectParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_subject_params_pb.SubjectParams, 8));
};


/**
 * @param {?proto.vehicle_params_for_phone.SubjectParams|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setSubjectParams = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearSubjectParams = function() {
  return this.setSubjectParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasSubjectParams = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated common.StringKeyValue vehicle_options = 9;
 * @return {!Array<!proto.common.StringKeyValue>}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getVehicleOptionsList = function() {
  return /** @type{!Array<!proto.common.StringKeyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_common_string_key_value_pb.StringKeyValue, 9));
};


/**
 * @param {!Array<!proto.common.StringKeyValue>} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setVehicleOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.common.StringKeyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.StringKeyValue}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.addVehicleOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.common.StringKeyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearVehicleOptionsList = function() {
  return this.setVehicleOptionsList([]);
};


/**
 * repeated common.StringKeyValue vehicle_overrides = 10;
 * @return {!Array<!proto.common.StringKeyValue>}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getVehicleOverridesList = function() {
  return /** @type{!Array<!proto.common.StringKeyValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_common_string_key_value_pb.StringKeyValue, 10));
};


/**
 * @param {!Array<!proto.common.StringKeyValue>} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setVehicleOverridesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.common.StringKeyValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.StringKeyValue}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.addVehicleOverrides = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.common.StringKeyValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearVehicleOverridesList = function() {
  return this.setVehicleOverridesList([]);
};


/**
 * optional sint32 minimum_api_version_minor = 14;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getMinimumApiVersionMinor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setMinimumApiVersionMinor = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional VehicleFeatures features = 16;
 * @return {?proto.vehicle_params_for_phone.VehicleFeatures}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getFeatures = function() {
  return /** @type{?proto.vehicle_params_for_phone.VehicleFeatures} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_vehicle_features_pb.VehicleFeatures, 16));
};


/**
 * @param {?proto.vehicle_params_for_phone.VehicleFeatures|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setFeatures = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearFeatures = function() {
  return this.setFeatures(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasFeatures = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional skills.ControlSchemeParams control_scheme = 17;
 * @return {?proto.skills.ControlSchemeParams}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getControlScheme = function() {
  return /** @type{?proto.skills.ControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_control_scheme_params_pb.ControlSchemeParams, 17));
};


/**
 * @param {?proto.skills.ControlSchemeParams|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearControlScheme = function() {
  return this.setControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasControlScheme = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional joysticks.RateLimits joysticks_rate_limits = 18;
 * @return {?proto.joysticks.RateLimits}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getJoysticksRateLimits = function() {
  return /** @type{?proto.joysticks.RateLimits} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_joysticks_rate_limits_pb.RateLimits, 18));
};


/**
 * @param {?proto.joysticks.RateLimits|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setJoysticksRateLimits = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearJoysticksRateLimits = function() {
  return this.setJoysticksRateLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasJoysticksRateLimits = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool offline_mode_enabled = 19;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getOfflineModeEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setOfflineModeEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool enable_map_quad_selector = 20;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getEnableMapQuadSelector = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setEnableMapQuadSelector = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional bool ignores_logging_sd_card = 21;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getIgnoresLoggingSdCard = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setIgnoresLoggingSdCard = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional CompatibilityInfo compatibility_info = 24;
 * @return {?proto.vehicle_params_for_phone.CompatibilityInfo}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getCompatibilityInfo = function() {
  return /** @type{?proto.vehicle_params_for_phone.CompatibilityInfo} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_compatibility_info_pb.CompatibilityInfo, 24));
};


/**
 * @param {?proto.vehicle_params_for_phone.CompatibilityInfo|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setCompatibilityInfo = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearCompatibilityInfo = function() {
  return this.setCompatibilityInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasCompatibilityInfo = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional ReturnSettingsLimits return_settings_limits = 25;
 * @return {?proto.vehicle_params_for_phone.ReturnSettingsLimits}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getReturnSettingsLimits = function() {
  return /** @type{?proto.vehicle_params_for_phone.ReturnSettingsLimits} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_return_settings_limits_pb.ReturnSettingsLimits, 25));
};


/**
 * @param {?proto.vehicle_params_for_phone.ReturnSettingsLimits|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setReturnSettingsLimits = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearReturnSettingsLimits = function() {
  return this.setReturnSettingsLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasReturnSettingsLimits = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional WaypointLimits waypoint_limits = 26;
 * @return {?proto.vehicle_params_for_phone.WaypointLimits}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getWaypointLimits = function() {
  return /** @type{?proto.vehicle_params_for_phone.WaypointLimits} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_waypoint_limits_pb.WaypointLimits, 26));
};


/**
 * @param {?proto.vehicle_params_for_phone.WaypointLimits|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setWaypointLimits = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearWaypointLimits = function() {
  return this.setWaypointLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasWaypointLimits = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional bool allow_autonomy_off = 27;
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getAllowAutonomyOff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setAllowAutonomyOff = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * repeated RunmodeSwitchingOption runmode_switching_options = 28;
 * @return {!Array<!proto.vehicle_params_for_phone.RunmodeSwitchingOption>}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getRunmodeSwitchingOptionsList = function() {
  return /** @type{!Array<!proto.vehicle_params_for_phone.RunmodeSwitchingOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_vehicle_params_for_phone_runmode_switching_option_pb.RunmodeSwitchingOption, 28));
};


/**
 * @param {!Array<!proto.vehicle_params_for_phone.RunmodeSwitchingOption>} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setRunmodeSwitchingOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 28, value);
};


/**
 * @param {!proto.vehicle_params_for_phone.RunmodeSwitchingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle_params_for_phone.RunmodeSwitchingOption}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.addRunmodeSwitchingOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 28, opt_value, proto.vehicle_params_for_phone.RunmodeSwitchingOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearRunmodeSwitchingOptionsList = function() {
  return this.setRunmodeSwitchingOptionsList([]);
};


/**
 * optional double max_height_gps_unreliable_indoors = 29;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getMaxHeightGpsUnreliableIndoors = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setMaxHeightGpsUnreliableIndoors = function(value) {
  return jspb.Message.setProto3FloatField(this, 29, value);
};


/**
 * optional double max_height_gps_unreliable = 33;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getMaxHeightGpsUnreliable = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setMaxHeightGpsUnreliable = function(value) {
  return jspb.Message.setProto3FloatField(this, 33, value);
};


/**
 * optional double max_height_gps_unreliable_night_autonomy = 34;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getMaxHeightGpsUnreliableNightAutonomy = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setMaxHeightGpsUnreliableNightAutonomy = function(value) {
  return jspb.Message.setProto3FloatField(this, 34, value);
};


/**
 * optional sint32 thermal_camera_rows = 30;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getThermalCameraRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setThermalCameraRows = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional sint32 thermal_camera_cols = 31;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getThermalCameraCols = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setThermalCameraCols = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional flir_boson_driver.AgcSettings default_thermal_agc_settings = 32;
 * @return {?proto.flir_boson_driver.AgcSettings}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getDefaultThermalAgcSettings = function() {
  return /** @type{?proto.flir_boson_driver.AgcSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flir_boson_driver_agc_settings_pb.AgcSettings, 32));
};


/**
 * @param {?proto.flir_boson_driver.AgcSettings|undefined} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
*/
proto.vehicle_params_for_phone.VehicleParams.prototype.setDefaultThermalAgcSettings = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.clearDefaultThermalAgcSettings = function() {
  return this.setDefaultThermalAgcSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.hasDefaultThermalAgcSettings = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional string enable_overlay_photo_key = 35;
 * @return {string}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getEnableOverlayPhotoKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setEnableOverlayPhotoKey = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional sint32 max_num_logs_prevent_deletion = 36;
 * @return {number}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getMaxNumLogsPreventDeletion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setMaxNumLogsPreventDeletion = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional string disable_lrv_recording_key = 37;
 * @return {string}
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.getDisableLrvRecordingKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_params_for_phone.VehicleParams} returns this
 */
proto.vehicle_params_for_phone.VehicleParams.prototype.setDisableLrvRecordingKey = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


goog.object.extend(exports, proto.vehicle_params_for_phone);
